import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import classNames from 'classnames';
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import { getRootComponent } from "../../utilities/ElementUtils";
import { displayField } from "../../utilities/ElementUtils";
import { fi } from "date-fns/locale";

interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
}

interface State {
 
}

export class MultiTextComponent extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);

   let field = this.props.field;
   FormValidationUtils.runJavascript(field);
  }

  valueLength(value) {
    if (typeof value == 'string') {
      return value.length;
    }
    return 0;
  }

  // wordCount(value) {
  //   if (typeof value == 'string' && value.trim().length > 0) {
  //     return value.trim().split(/\s+/).length;
  //   }
  //   return 0;
  // }
charCount(value) {
  if (typeof value === 'string') {
    return value.length;
  }
  return 0;
}

  getMaxLength(): number {
    let field = this.props.field;
    let lengthAndRow = field.maxLength?.toString() || field.Length;
    let maxLength = 6000; // default max length

    if (lengthAndRow && lengthAndRow.indexOf("--") > 0) {
      const arr = lengthAndRow.split('--');
      const substrings = arr[1].split('-');
      maxLength = parseInt(substrings[0].toString(), 10);
    } else if (lengthAndRow) {
      maxLength = parseInt(lengthAndRow);
    } else if (field.maxLength) {
      maxLength = field.maxLength;
    }

    return maxLength;
  }

  isWithinWordLimit(value: string): boolean {
    const currentWordCount = this.charCount(value);
    const maxLength = this.getMaxLength();
    return currentWordCount <= maxLength;
  }

  truncateToMaxWords(value: string, maxWords: number): string {
    if (typeof value !== 'string' || value.trim().length === 0) {
      return value;
    }
    
    if (value.length <= maxWords) {
      return value;
    }
    
    return value.slice(0, maxWords);
  }

  onTextEditChange = (e) => {
    let field =  this.props.field;
    let elem = e.originalEvent ? e.originalEvent.target : e.target;
    let val = elem.value;

    const maxLength = this.getMaxLength();
    const exceededLimit = this.valueLength(val) > maxLength;

    if (!this.isWithinWordLimit(val)) {
      val = this.truncateToMaxWords(val, maxLength);
    }

    field.Value = val;
 
    FormValidationUtils.validateText(field);
    FormValidationUtils.evalRegularExpression(field);
    FormValidationUtils.runJavascript(field);

    if (exceededLimit) {
      field.Valid = false;
    }
   
    this.props.callbackElement(getRootComponent(this.props.field));
  }

  onKeyDown = (e) => {
    const field = this.props.field;
    const maxLength = this.getMaxLength();
    const currentWordCount = this.charCount(field.Value);

    if (e.key === ' ' && currentWordCount >= maxLength) {
      e.preventDefault();
    }
  }

  getCharacterHintMessage() {
    let field = this.props.field;
    const maxLength = this.getMaxLength();
    const currentLength = this.valueLength(field.Value);

    if (currentLength <= maxLength) {
      const remaining = maxLength - currentLength;
      return this.props.isEng
        ? `You have ${remaining} characters remaining.`
        : `Il vous reste ${remaining} caractères.`;
    }

    return this.props.isEng
      ? `You have reached the limit.`
      : `Vous avez atteint la limite.`;
  }

  render() {
    let field = this.props.field;

    field.Visible = field.Visible ?? true;
    let displayfield: boolean = true;
    let editable = this.props.editable;
    let labelControlArray = this.props.labelControlArray;
    let requiredField = this.props.requiredField;
    let controlArray = [];
    let title = this.props.title;
    let isCounterDisplay = field.counterVisible;

    displayfield = displayField(field);
    this.props.field.Visible = displayfield;

    const maxLength = this.getMaxLength();
    const currentLength = this.valueLength(field.Value);
    const shouldShowHint = isCounterDisplay && currentLength > 0;
    let hintHtml = this.props.isEng ? field.Hint : field.HintFR;

    const sectionReadOnly = field.parent?.parent?.SectionReadonly === true;
    const inputReadOnly = sectionReadOnly || !editable;
    field.ReadOnly = inputReadOnly;

    if (currentLength > maxLength) {
      field.Valid = false;
    }

    if (displayfield) {
      if (editable) {
        if (field.Value == null)
          field.Value = '';

        controlArray.push(
          <div key={'div_' + field.Datatype +'_' + field.Id} id= {'div_' + field.Datatype +'_' + field.Id}     className="ontario-form-group" >
            {labelControlArray}
            <LiveValidationErrMsg
              field={this.props.field}
              isEng={this.props.isEng}
              key={"LiveValidationErrMsg_" +this.props.field.LoadBindName}
            />
            <textarea
              className={field.Valid ? "ontario-input ontario-textarea": "ontario-input ontario-textarea ontario-input__error"}
              id={field.LoadBindName}
              key={'fdIpt_textarea_' + field.Id}
              required={requiredField}
              value={field.Value}
              rows={3}
              maxLength={maxLength}
              aria-invalid={!field.Valid ? true : undefined}
              readOnly={inputReadOnly}
              aria-describedby={
                [!field.Valid && `${field.LoadBindName}-${field.Id}-error`, hintHtml && `hint-text-${field.LoadBindName}`]
                  .filter(Boolean)
                  .join(' ') || undefined
              }
              onChange={this.onTextEditChange}
              onKeyDown={this.onKeyDown}
              placeholder={field.enuToolTip || undefined}
              style={field.isResizeNotAllowed ? { resize: 'none' } : undefined}
            ></textarea>
            {shouldShowHint && (
              <p className="ontario-hint ontario-character-counter-hint">
                {this.getCharacterHintMessage()}
              </p>
            )}
          </div>
        );
      } else {
        if (field.EGMSStyle == 'Row') {
          controlArray.push(
            <div key={'div_' + field.Datatype +'_' + field.Id}>
              <div key={'div2_' + field.Datatype +'_' + field.Id}>{title}</div>
              <div key={'div3_' + field.Datatype +'_' + field.Id} style={{ whiteSpace: 'pre-line' }}>{field.Value}</div>
            </div>)
        } else {
          // Access programContainer
          const programContainer = getRootComponent(field);
          controlArray.push(
            <div key={'div_' + field.Datatype +'_' + field.Id} className={programContainer.isHorizontalLayout ? 'pdf-row-column' : 'pdf-two-column'}>
              <div key={'div2_' + field.Datatype +'_' + field.Id}>{title}</div>
              <div key={'div3_' + field.Datatype +'_' + field.Id} className={classNames({ 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })} >{field.Value}</div>
            </div>
          );
        }
      }
    }

    return controlArray;
  }
}
